import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OnboardingAgentLicensesOptOut } from 'src/app/shared/models/onboarding.models';
import { OnboardingApiService } from '../http/onboarding-api.service';

@Injectable({
  providedIn: 'root'
})
export class AgentLicenseOptOutResolver implements Resolve<Observable<OnboardingAgentLicensesOptOut | null>> {

  constructor(private onboardingApiService: OnboardingApiService) {
  }

  resolve(): Observable<OnboardingAgentLicensesOptOut | null> {
    return this.onboardingApiService.getUserAgentLicensesOptOut().pipe(catchError(() => of(null)));
  }
}